import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

const AddOptionInput = ({
  inputValue,
  onInputChange,
  onClick,
  placeholderText,
  ariaLabel,
  autoFocus = true,
}) => {
  const [isAdding, setIsAdding] = useState(true);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const initialRender = useRef(true);

  const handleButtonClick = () => (
    isAdding && onClick(), setIsAdding((prev) => !prev)
  );

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (isAdding) {
      inputRef.current?.focus();
    } else {
      buttonRef.current?.focus();
    }
  }, [isAdding]);

  useEffect(() => {
    if (autoFocus && !initialRender.current && isAdding) {
      inputRef.current?.focus();
    }
  }, [autoFocus, isAdding]);

  if (!onInputChange || !onClick) return null;
  return (
    <div
      className={classNames({
        'c-letter-slide__add-button': true,
        'c-letter-slide__add-button--is-open': isAdding,
      })}
    >
      {isAdding && (
        <input
          ref={inputRef}
          type="text"
          placeholder={placeholderText || 'Lägg till ett alternativ'}
          value={inputValue}
          aria-label={ariaLabel}
          onChange={(e) => onInputChange(e)}
          onKeyDown={(e) => handleKeyDown(e)}
        />
      )}

      <button ref={buttonRef} onClick={handleButtonClick}>
        <span>{isAdding ? 'Lägg till' : 'Lägg till eget alternativ'}</span>
      </button>
    </div>
  );
};

export default AddOptionInput;
